import { z } from 'zod';

import { createEventBus } from './utils/createEventBus';
import { singleton } from './utils/singleton';

export const LoginEventSchema = z.object({
  AccessToken: z.string(),
  IdToken: z.string(),
  redirectTo: z.string().optional(),
});

export const LogoutEventSchema = z.object({
  success: z.boolean(),
});

export const PostHogCaptureEventSchema = z.object({
  event: z.string(),
  properties: z.record(z.any()).optional(),
});

export const PostHogIdentifyEventSchema = z.object({
  distinctId: z.string(),
  properties: z.record(z.any()).optional(),
});

export const PostHogResetEventSchema = z.object({
  resetDeviceId: z.boolean().optional(),
});

export const OpenTopUpModalEventSchema = z.object({});

export const SavingsPointsLoadedEventSchema = z.object({});

// TT-137: the sole channel the Vue complete-profile page uses to hand its
// just-saved values to the host. Carries birthdate + phone_number so the host
// can clear the completion gate optimistically (no token refresh, no re-login).
export const ProfileCompletedEventSchema = z.object({
  birthdate: z.string(),
  phone_number: z.string(),
  redirectTo: z.string().optional(),
});

// TT-133: host relays enable-wakala-widget to version-one (Vue can't read
// GrowthBook). Carries the resolved flag value.
export const WakalaWidgetFlagEventSchema = z.object({
  enabled: z.boolean(),
});

// TT-133: version-one asks the host to (re-)emit the flag, so it gets the value
// whenever it subscribes regardless of flag-load timing.
export const RequestWakalaWidgetFlagEventSchema = z.object({});

// TT-199: fired by the Vue investor-type page once a declaration has been accepted, so the
// host can drop its cached declaration / investment-details reads. No payload - the host
// refetches rather than trusting anything passed across the boundary.
export const InvestorDeclarationSubmittedEventSchema = z.object({});

// TT-260: host relays enable-waqf to version-one, the same arrangement as the
// Wakala pair above and for the same reason - Vue cannot read GrowthBook.
// Carries the resolved flag value.
export const WaqfFlagEventSchema = z.object({
  enabled: z.boolean(),
});

// TT-260: version-one asks the host to (re-)emit the flag, so it gets the value
// whenever it subscribes regardless of flag-load timing.
export const RequestWaqfFlagEventSchema = z.object({});

const eventConfig = {
  'mife:login': LoginEventSchema,
  'mife:logout': LogoutEventSchema,
  'posthog:capture': PostHogCaptureEventSchema,
  'posthog:identify': PostHogIdentifyEventSchema,
  'posthog:reset': PostHogResetEventSchema,
  'mife:open-top-up-modal': OpenTopUpModalEventSchema,
  'mife:savings-points-loaded': SavingsPointsLoadedEventSchema,
  'mife:profile-completed': ProfileCompletedEventSchema,
  'mife:wakala-widget-flag': WakalaWidgetFlagEventSchema,
  'mife:request-wakala-widget-flag': RequestWakalaWidgetFlagEventSchema,
  'mife:investor-declaration-submitted': InvestorDeclarationSubmittedEventSchema,
  'mife:waqf-flag': WaqfFlagEventSchema,
  'mife:request-waqf-flag': RequestWaqfFlagEventSchema,
};

export const initEventBus = () => singleton('eventBus', () => createEventBus(eventConfig));
